module.exports = __webpack_public_path__ + "static/media/USDB.687f685f.png";